import { Link, KeyboardArrowDownIcon, ProductsSubmenu, CustomMenu, RotatedBadge, Stack } from '@zageno/ui';
import type { ProductCategory } from '@zageno/ui';
import React, { MouseEvent } from 'react';
import { navigateToUrlAndPreventDefault } from '../../utils';
import { selectOnlyDesktopPages } from '../../features/header/pagesSlice';
import { useAppSelector, useCategoriesAdapter } from '../../hooks';
import { Category, Page } from '../../api';

export function NavigationLink({
  page,
  categories,
  index,
}: Readonly<{ page: Page; categories: Category[]; index: number }>) {
  const link = (
    <Link
      data-testid="navigation-link"
      key={`link-${index + 1}`}
      href={page.link}
      onClick={(event: MouseEvent<HTMLAnchorElement>) => navigateToUrlAndPreventDefault(page, event)}
      underline="none"
      sx={{ my: 2, ml: 2, mr: 2, color: 'gray.dark', display: 'block', fontWeight: 'bold' }}
    >
      {page.title}

      {page.dropdown && <KeyboardArrowDownIcon sx={{ verticalAlign: 'middle' }} />}
    </Link>
  );

  let item;

  if (page.dropdown && categories.length >= 1) {
    item = (
      <ProductsSubmenu categories={categories as ProductCategory[]} key={`product-submenu-${index + 1}`}>
        {link}
      </ProductsSubmenu>
    );
  } else if (page.items) {
    item = (
      <CustomMenu items={page.items} key={`custom-submenu-${index + 1}`}>
        {link}
      </CustomMenu>
    );
  } else {
    item = link;
  }

  if (page.badge) {
    item = <RotatedBadge badgeContent={page.badge}>{item}</RotatedBadge>;
  }

  return <div key={page.title}>{item}</div>;
}

export default function DesktopNavigation() {
  const pages = useAppSelector(selectOnlyDesktopPages);
  const categories = useCategoriesAdapter();

  return (
    <>
      {pages.map((page, index) => (
        <NavigationLink page={page} categories={categories} index={index} key={`custom-submenu-${index + 1}`} />
      ))}
      <CustomMenu items={pages.slice(2).map(page => ({ title: page.title, link: page.link }))} clickToOpen>
        <Stack
          direction="row"
          alignItems="center"
          spacing={1}
          sx={{
            height: '100%',
            p: 2,
            display: { lg: 'none' },
            fontWeight: 'bold',
            color: 'gray.dark',
          }}
        >
          <span>More</span>
          <KeyboardArrowDownIcon sx={{ verticalAlign: 'middle' }} />
        </Stack>
      </CustomMenu>
    </>
  );
}
